// extracted by mini-css-extract-plugin
export default {"card":"AuthCard_card__BvW1H","auth":"AuthCard_auth__TIwuJ"};